export const CREATED = 'CREATED';
export const PARTIALLY_CREATED = 'PARTIALLY_CREATED';
export const NOT_CREATED = 'NOT_CREATED';
